<template>
  <v-dialog :value="value" max-width="500" persistent content-class="glass-dialog-wrapper">
    <v-card class="glass-card-dark elevation-24">
      <v-card-title class="white--text">
        <v-icon left :color="data?.template.color">{{ data?.template.icon }}</v-icon>
        {{ data?.template.title }}
      </v-card-title>

      <v-card-text class="pt-4 overflow-visible">
        <div class="d-flex justify-space-between align-center mb-4 glass-panel-light pa-3 rounded border-light">
          <div>
            <div class="caption grey--text">Mitarbeiter</div>
            <div class="font-weight-bold white--text">{{ data?.col.firstName }}</div>
          </div>
          <div class="d-flex align-center gap-2">
            <v-text-field
              v-if="data"
              v-model="localStart"
              label="Start"
              type="time"
              dense
              hide-details
              outlined
              dark
              class="centered-input"
              style="width: 90px"></v-text-field>
            <v-text-field
              v-if="data && data.template.type === 'appointment'"
              v-model.number="localDuration"
              label="Min"
              type="number"
              dense
              hide-details
              outlined
              dark
              class="centered-input"
              style="width: 80px"></v-text-field>
          </div>
        </div>

        <div class="text-right caption grey--text mb-4">
          Ende: <span class="white--text font-weight-bold">{{ calculatedEnd }}</span>
        </div>

        <div v-if="data?.template.requiresCustomer" class="mb-4 relative" style="z-index: 1000">
          <div class="caption grey--text mb-1">Kunde auswählen *</div>
          <user-search
            :value="selectedCustomer"
            @update="updateCustomer"
            return-object
            ignore-rights
            label="Kunden suchen..."
            dark
            outlined
            dense
            :menu-props="{ zIndex: 9999, offsetY: true }"></user-search>
        </div>

        <v-textarea v-if="data" v-model="localDesc" label="Notiz / Details (Optional)" outlined dense rows="2" dark></v-textarea>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click="$emit('input', false)">Abbrechen</v-btn>
        <v-btn
          color="success"
          depressed
          class="font-weight-bold black--text"
          @click="save"
          :disabled="data?.template.requiresCustomer && !selectedCustomer">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserSearch from "@/components/userSearch" // Pfad prüfen!
import moment from "moment"

export default {
  name: "WorkCalendarDropDialog",
  components: { UserSearch },
  props: ["value", "data"],
  data() {
    return {
      localStart: "",
      localDuration: 60,
      localDesc: "",
      selectedCustomer: null,
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val) {
          this.localStart = val.time
          this.localDuration = val.template.duration || 60
          this.localDesc = val.description
          this.selectedCustomer = null
        }
      },
    },
  },
  computed: {
    calculatedEnd() {
      if (!this.localStart) return "-"
      return moment(this.localStart, "HH:mm").add(this.localDuration, "minutes").format("HH:mm")
    },
  },
  methods: {
    updateCustomer(value) {
      this.selectedCustomer = value
    },
    save() {
      console.log("preemit", this.selectedCustomer)
      this.$emit("save", {
        ...this.data,
        time: this.localStart,
        duration: this.localDuration,
        description: this.localDesc,
        customer: this.selectedCustomer,
      })
    },
  },
}
</script>

<style scoped>
.glass-card-dark {
  background: rgba(30, 30, 30, 0.98);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.glass-panel-light {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.overflow-visible {
  overflow: visible !important;
}
.centered-input >>> input {
  text-align: center;
  font-weight: bold;
}
.gap-2 {
  gap: 8px;
}
</style>
